import { ChangeRequest } from 'models';
import { useQuery } from 'query';
import { getChangeRequest } from '../services/change-requests';
import { getChangeRequestsQueryKey } from './keys';

export const useChangeRequestsQuery = ({
  changeRequestId,
  invitationToken,
}: {
  changeRequestId?: string;
  invitationToken?: string;
}) =>
  useQuery<ChangeRequest>({
    enabled: changeRequestId !== undefined && invitationToken !== undefined,
    async queryFn() {
      const response = await getChangeRequest({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Is defined in runtime
        changeRequestId: changeRequestId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Is defined in runtime
        invitationToken: invitationToken!,
      });
      return new ChangeRequest(response.data);
    },
    queryKey: getChangeRequestsQueryKey(changeRequestId),
  });
